import { gql } from '@apollo/client'

export default gql`
  subscription GetLiveMonitorBookParticipants($readingIds: [uuid!]!) {
    view_reading_room_book(where: { reading_id: { _in: $readingIds } }) {
      reading_id
      user_id
      person_name
      reading {
        readingevents {
          readingstate {
            name
            created
          }
        }
      }
    }
  }
`
